// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1AVYQ","location":"Header_location__JquTN"};